import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICurrency } from '@shared/interfaces/currency.interface';
import { ILoadUsers } from '@shared/interfaces/user.interface';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminSettingsTagsService {

  
  constructor(private http: HttpClient) { }

  

  loadTags(){
    let url = environment.apiUrl + `/tags?count=50`;
    return this.http.get(url);
  }

  loadDeliveryData(){
    let url = environment.apiUrl + `/all-delivery-data`;
    return this.http.get(url);
  }

  createDeliverData(body: any) {
    let url = environment.apiUrl + `/addDeliveryData`;
    return this.http.post(url, body);
  }

  editDeliverData(body: any) {
    let url = environment.apiUrl + `/editDeliveryData`;
    return this.http.post(url, body);
  }

  deleteDeliverData(body: any) {
    let url = environment.apiUrl + `/deleteDeliveryData`;
    return this.http.post(url, body);
  }

  createTag(body: any) {
    let url = environment.apiUrl + `/operator/tags`;
    return this.http.post(url, body);
  }

  createSubTag(body: any, id:number) {
    let url = environment.apiUrl + `/operator/subtags/${id}`;
    return this.http.post(url, body);
  }

  getImgAsBlob(url:string){
    return this.http.get(url, {responseType: 'blob'});
  }


  editTag(body: any, id:number) {
    let url = environment.apiUrl + `/operator/tags/${id}`;
    return this.http.post(url, body);
  }

  editSubTag(body: any, id:number, subtagid:number) {
    let url = environment.apiUrl + `/operator/tags/${id}/subtags/${subtagid}`;
    return this.http.post(url, body);
  }

  deleteTag(id: number) {
    let url = environment.apiUrl + `/operator/tags/${id}`;
    return this.http.delete(url);
  }

  deleteSubTag(id: number) {
    let url = environment.apiUrl + `/operator/subtags/${id}`;
    return this.http.delete(url);
  }

  changeTagPosition(body:any) {
    let url = environment.apiUrl + `/operator/tagsPosition`;
    return this.http.post(url, body);
  }
  
}
